/**
 *
 * SelectLeadershipRecipients
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Input, Table } from "antd"
import { isEqual, isEmpty, flatMap, filter, debounce, uniq } from "lodash"
import ModalSelectLeadership from "../ModalSelectLeadership"
import Loader from "components/Loader"
import { columns } from "./columns"
import "./index.less"
import { SearchOutlined } from "@ant-design/icons"

class SelectLeadershipRecipients extends React.Component {
  state = {
    searchLeader: "",
    modalSelectLeadership: false,
    leaderSelected: {},
    employees: [],
    leaders: [],
  }

  componentDidMount = () => {
    this.setState(
      {
        employees: this.props.secondStepData.employees,
        leaders: this.props.secondStepData.divisions,
      },
      () => {
        this.props.setStateFrom("collaboratorsSelected", this.state.employees)
        this.props.setStateFrom("selectedEmployees", this.state.employees)
      }
    )
    if (this.props.measure.id_scope_type === 1) {
      this.props.getLeadersWatcher({ segments: [] })
    } else {
      const segments = this.props.measure.segments.map(
        (item) => item.id_segment
      )
      const params = { segments }
      this.props.getLeadersWatcher(params)
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevState.employees, this.state.employees)) {
      this.props.setStateFrom("selectedEmployees", this.state.employees)
    }
    if (!isEqual(prevProps.secondStepData, this.props.secondStepData)) {
      if (isEmpty(this.props.secondStepData)) return

      if (this.props.secondStepData.employees.length > 0) {
        this.setState(
          {
            employees: this.props.secondStepData.employees,
            leaders: this.props.secondStepData.divisions,
          },
          () => {
            this.props.setStateFrom(
              "collaboratorsSelected",
              this.state.employees
            )
            this.props.setStateFrom("selectedEmployees", this.state.employees)
          }
        )
      }
    }

    if (this.props.getLeaders.length !== prevProps.getLeaders.length) {
      const { secondStepData, getLeaders } = this.props
      const validationEmployees = () => {
        if (secondStepData.employees) {
          if (secondStepData.employees.length > 0) {
            return false
          }
          return true
        }
        return true
      }
      if (validationEmployees() && getLeaders.length) {
        const teamsLessThan = filter(
          getLeaders,
          (leader) => leader.team.length >= Number(secondStepData.anonymity)
        )

        const idsLeaders = flatMap(
          teamsLessThan,
          (leader) => leader.id_employee
        )
        const teams = flatMap(teamsLessThan, (leader) => leader.team)
        let idsTeams = []

        if (secondStepData.employees) {
          if (secondStepData.employees.length === 0) {
            idsTeams = flatMap(teams, (employee) => employee.employee_id)
          } else {
            idsTeams = secondStepData.employees
          }
        } else {
          idsTeams = flatMap(teams, (employee) => employee.employee_id)
        }

        return this.setState(
          {
            leaders: idsLeaders,
            employees: idsTeams,
          },
          () => {
            this.debounceSendToServer()
            this.props.setStateFrom("selectedEmployees", this.state.employees)
            this.props.setStateFrom(
              "collaboratorsSelected",
              this.state.employees
            )
          }
        )
      }

      const filterIdsParents = filter(this.props.getLeaders, (leader) => {
        if (leader.team.length) {
          const getOnlyIds = flatMap(leader.team, (item) => item.employee_id)
          const filterChildrens = filter(this.state.employees, (item) =>
            getOnlyIds.includes(item)
          )

          if (filterChildrens.length == leader.collaborators_quantity) {
            return leader.id_employee
          }
        }
      })

      const flatMapIds = flatMap(filterIdsParents, (item) => item.id_employee)

      this.setState({ leaders: uniq([...this.state.leaders, ...flatMapIds]) })
    }
  }

  sendToServer = () => {
    const { leaders, employees } = this.state

    const params = {
      idMeasurement: this.props.idMeasurement,
      params: {
        divisions: uniq(leaders),
        auto_save: true,
        employees: uniq(employees),
      },
    }

    this.props.setStateFrom("collaboratorsSelected", this.state.employees)
    this.props.setStateFrom("selectedEmployees", this.state.employees)

    // this.props.stepTwoWatcher(params)
  }

  debounceSendToServer = debounce(this.sendToServer, 300)

  setStateFrom = (name, value, leaderSelected = {}) => {
    if (!isEmpty(leaderSelected)) {
      return this.setState({
        [name]: value,
        leaderSelected,
      })
    }

    this.setState({ [name]: value }, () => {
      this.props.setStateFrom("collaboratorsSelected", this.state.employees)
      this.props.setStateFrom("selectedEmployees", this.state.employees)
      this.debounceSendToServer()
    })
  }

  searchLeaderFunc = () => {
    const { searchLeader } = this.state

    if (!Array.isArray(this.props.getLeaders)) return []

    if (searchLeader) {
      return filter(this.props.getLeaders, (item) => {
        return item.full_name_employee
          .toLowerCase()
          .includes(searchLeader.toLocaleLowerCase())
      })
    }

    return this.props.getLeaders
  }

  debounceSearchLeaderFunc = debounce(this.searchLeaderFunc, 300)

  render() {
    const { searchLeader } = this.state

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {},
      onSelect: (record, selected, selectedRows) => {
        const employeesIds = flatMap(record.team, (item) => item.employee_id)

        if (selected) {
          return this.setState(
            {
              employees: [...this.state.employees, ...employeesIds],
              leaders: [...this.state.leaders, record.id_employee],
            },
            () => this.sendToServer()
          )
        }

        this.setState(
          {
            leaders: filter(
              this.state.leaders,
              (item) => item !== record.id_employee
            ),
            employees: filter(
              this.state.employees,
              (item) => !employeesIds.includes(item)
            ),
          },
          () => this.sendToServer()
        )
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        let leadersIds = []
        let employeesIds = []

        if (selected) {
          const employeesTeam = flatMap(selectedRows, (item) => {
            if (item) return item.team
          })
          employeesIds = flatMap(employeesTeam, (item) => {
            if (item) return item.employee_id
          })
          leadersIds = flatMap(selectedRows, (item) => {
            if (item) return item.id_employee
          })

          this.setState(
            {
              leaders: leadersIds.filter((item) => item),
              employees: employeesIds.filter((item) => item),
            },
            () => this.sendToServer()
          )
        } else {
          this.setState(
            {
              leaders: [],
              employees: [],
            },
            () => this.sendToServer()
          )
        }
      },
      getCheckboxProps: (record) => {
        const anonymity = Number(this.props.secondStepData.anonymity) || 3
        return {
          disabled: record.team.length < anonymity,
          name: record.name,
        }
      },
      selectedRowKeys: this.state.leaders,
    }

    if (this.props.isLoadingSecondStepData) {
      return <Loader />
    }

    return (
      <React.Fragment>
        <div className="select-leadership-recipients">
          <div className="select-leadership-recipients-header">
            <p>Seleccionar destinatarios</p>
            <p>
              Selecciona los equipos a las que deseas enviar la encuesta.
              <span> ¡Recuerda! </span>
              Debes seleccionar un mínimo de{" "}
              <span>
                {Number(this.props.secondStepData.anonymity) || 3}
              </span>{" "}
              colaboradores por equipo para que la encuesta les sea enviada.
            </p>
            <Input
              style={{ width: 355 }}
              allowClear
              suffix={!searchLeader && <SearchOutlined />}
              value={searchLeader}
              placeholder="Buscar líder..."
              onChange={(e) => this.setState({ searchLeader: e.target.value })}
            />
          </div>
          <div className="select-leadership-recipients-body">
            <div className="total-recipients">
              Total de destinatarios: {this.state.employees.length}
            </div>
            <Table
              bordered
              className="select-leadership-recipients-table"
              loading={this.props.isLoadingGetLeaders}
              dataSource={this.searchLeaderFunc()}
              columns={columns(
                this.setStateFrom,
                this.state.employees,
                this.props.secondStepData
              )}
              rowSelection={rowSelection}
              rowKey={(record) => record.id_employee}
              rowClassName={(record) => {
                const {
                  secondStepData: { employees },
                } = this.props

                const employeesFlatMap = flatMap(
                  record.team,
                  (item) => item.id_employee
                )
                const hasAllEmployees = filter(employees, (employee) =>
                  employeesFlatMap.includes(employee)
                )

                if (
                  hasAllEmployees.length &&
                  hasAllEmployees.length != record.collaborators_quantity
                ) {
                  return "no-select-all-items"
                }

                if (
                  hasAllEmployees.length &&
                  hasAllEmployees.length == record.collaborators_quantity
                ) {
                  // this.setState({
                  //   leaders: uniq([...this.state.leaders, record.employee_id])
                  // })
                }
              }}
              pagination={{
                pageSizeOptions: ["15", "25", "50", "100"],
                showSizeChanger: true,
                size: "default",
                defaultPageSize: 15,
              }}
            />
          </div>
        </div>
        <ModalSelectLeadership
          visible={this.state.modalSelectLeadership}
          setStateFrom={this.setStateFrom}
          leaderSelected={this.state.leaderSelected}
          stepTwoWatcher={this.props.stepTwoWatcher}
          idMeasurement={this.props.idMeasurement}
          leaders={this.state.leaders}
          employees={this.state.employees}
          anonymity={this.props.secondStepData.anonymity || 3}
          isLoadingSecondStepData={this.props.isLoadingSecondStepData}
        />
      </React.Fragment>
    )
  }
}

SelectLeadershipRecipients.propTypes = {}

export default SelectLeadershipRecipients
